import { NO_FIELDS_ERROR } from '../../../../utils/formValidation/commonErrorConstants';
import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';

export const validate = (newEntry, formType, initialEntry) => {
    let newErrors = {};

    if (Object.values(newEntry).filter(el => el).length < 2) {
        newErrors = {
            ...newErrors,
            button: { error: true, message: NO_FIELDS_ERROR }
        };
    }

    if (Object.keys(newErrors).length < 1 && formType === 'edit') {
        newErrors = checkDiff(newEntry, initialEntry);
    }

    return newErrors;
};
